/*
================================================
Une mixin gérant la génération de couleur pour illustrer les données de groupement dans la reportView summary
https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/

import _ from "lodash";

var  colorMixin = {
    created(){
    },

    data: function () {
        return {
            name: 'colorMixin',
            colors:
            // un array de couleurs pour identifier les groupes
            // pris sur https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=FF8A65 dans la colonne "300"
                [
                    {name:'blue',code:'64b5f6'},
                    {name:'green',code:'81c784'},
                    {name:'orange',code:'ffb74d'},
                    {name:'pink',code:'f06292'},
                    {name:'red',code:'e57373'},
                    {name:'purple',code:'ba68c8'},
                    {name:'blue grey',code:'90a4ae'},
                    {name:'teal',code:'4db6ac'},
                    {name:'cyan',code:'4dd0e1'},
                    {name:'light green',code:'aed581'},
                    {name:'amber',code:'ffd54f'},
                    {name:'deep orange',code:'ff8a65'},
                    {name:'deep purple',code:'9575cd'},
                    {name:'indigo',code:'7986cb'},
                    {name:'light blue',code:'4fc3f7'},
                    // {name:'lime',code:'dce775'},
                    // {name:'yellow',code:'fff176'},
                ],
        }
    },
    methods: {
        /**
         * Multiplie et retourne le tableau this.groupColor afin qu' un appel à this.groupColor[index] retourne toujours une valeur (incrémentée par rapport à la valeur précédente de index).
         *
         * Permet lorsque l'on appel defineColor dans une boucle de toujours retourner la valeur suivante appel après appel.
         *
         * @param index int
         * @return {{code: string, name: string}|{code: string, name: string}|{code: string, name: string}|{code: string, name: string}|{code: string, name: string}}
         */
        iterativeColor: function (index ) {

            let extendedArray = this.colors
            let length = this.colors.length

            let multipleRequired = Math.ceil( index / length) // arrondi vers le haut
            // console.warn("il faut multiplier le tableau par " + multipleRequired + ' pour index '+ index)

            for (let i = 0; i < multipleRequired  ; i++) {
               extendedArray =  _.concat(extendedArray,this.colors)
            }

            return extendedArray[index]
        },

    },

}

export default colorMixin;

